var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c(
        "el-container",
        [
          _c(
            "el-aside",
            {
              staticStyle: { "border-right": "1px solid #e6ebf5" },
              attrs: { width: "20%" },
            },
            [
              _c(
                "div",
                { staticClass: "slot-tree" },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.refreshTree },
                        },
                        [_vm._v("资源目录树")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-tree", {
                    key: _vm.treeKeyId,
                    attrs: {
                      data: _vm.resTreeData,
                      "node-key": "resId",
                      props: _vm.resTreeProp,
                      "highlight-current": true,
                    },
                    on: { "node-click": _vm.handleNodeClick },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var node = ref.node
                          var data = ref.data
                          return [
                            _c("span", { staticClass: "custom-tree-node" }, [
                              _c("span", [_vm._v(_vm._s(node.label))]),
                              _vm._v(" "),
                              data.type !== 3
                                ? _c(
                                    "span",
                                    { staticClass: "append" },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "text",
                                          size: "mini",
                                          icon: "el-icon-circle-plus",
                                        },
                                        on: {
                                          click: function () {
                                            return _vm.handleCreate(data)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "append" },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "text",
                                      size: "mini",
                                      icon: "el-icon-edit-outline",
                                    },
                                    on: {
                                      click: function () {
                                        return _vm.handleUpdate(data)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "append" },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "text",
                                      size: "mini",
                                      icon: "el-icon-delete",
                                    },
                                    on: {
                                      click: function () {
                                        return _vm.handleDelete(data)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-main",
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-container" },
                      [
                        _c("el-input", {
                          staticClass: "filter-item",
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "请输入资源名" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleFilter($event)
                            },
                          },
                          model: {
                            value: _vm.listQuery.keywords,
                            callback: function ($$v) {
                              _vm.$set(_vm.listQuery, "keywords", $$v)
                            },
                            expression: "listQuery.keywords",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [{ name: "waves", rawName: "v-waves" }],
                            staticClass: "filter-item",
                            attrs: { type: "primary", icon: "el-icon-search" },
                            on: { click: _vm.handleFilter },
                          },
                          [_vm._v("搜索")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              type: "primary",
                              icon: "el-icon-circle-plus-outline",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleCreate(null)
                              },
                            },
                          },
                          [_vm._v("新建")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.total > 0
                      ? _c("sw-page", {
                          key: "1",
                          attrs: {
                            listQuery: _vm.listQuery,
                            total: _vm.total,
                            pos: "topLeft",
                          },
                          on: { retPage: _vm.retPage },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.listLoading,
                            expression: "listLoading",
                          },
                        ],
                        key: _vm.tableKey,
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.list,
                          size: "mini",
                          stripe: "",
                          border: "",
                          fit: "",
                          "highlight-current-row": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "名称",
                            align: "left",
                            width: "120",
                            prop: "name",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "编码",
                            align: "center",
                            prop: "code",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "权限",
                            align: "center",
                            prop: "perms",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "路由路径",
                            align: "center",
                            prop: "routerPath",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "资源级别",
                            align: "center",
                            width: "100",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm._f("systemFilter")(row.system))
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            align: "center",
                            width: "300",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  row.type !== 3
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            title: "新建",
                                            icon: "el-icon-circle-plus-outline",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleCreate(row)
                                            },
                                          },
                                        },
                                        [_vm._v("新建")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        title: "编辑",
                                        icon: "el-icon-edit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleUpdate(row)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        icon: "el-icon-delete",
                                        title: "删除",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.total > 0
                      ? _c("sw-page", {
                          key: "2",
                          attrs: {
                            listQuery: _vm.listQuery,
                            total: _vm.total,
                            pos: "btmRight",
                          },
                          on: { retPage: _vm.retPage },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "菜单资源",
            visible: _vm.dialogFormVisible,
            wrapperClosable: false,
            size: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm.textMap[_vm.dialogStatus])),
                      ]),
                      _vm._v(" "),
                      _vm.parentMenu.code !== null
                        ? _c(
                            "span",
                            [
                              _c(
                                "el-tag",
                                { attrs: { type: "success", size: "mini" } },
                                [_vm._v(_vm._s(_vm.parentMenu.name))]
                              ),
                              _vm._v(" "),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-tag",
                                { attrs: { type: "success", size: "mini" } },
                                [_vm._v(_vm._s(_vm.parentMenu.code))]
                              ),
                              _vm._v(" "),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _vm._v(" "),
                              _vm.parentMenu.type === 1
                                ? _c("span", [_vm._v("二级菜单")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.parentMenu.type === 2
                                ? _c("span", [_vm._v("按钮")])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c("span", [
                            _vm._v("\n            一级菜单\n          "),
                          ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "dataForm",
                      attrs: {
                        rules: _vm.rules,
                        model: _vm.midData,
                        "label-position": "right",
                        "label-width": "90px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false",
                            },
                          ],
                          attrs: { label: "ID" },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.midData.resId,
                              callback: function ($$v) {
                                _vm.$set(_vm.midData, "resId", $$v)
                              },
                              expression: "midData.resId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "名称", prop: "name" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.midData.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.midData, "name", $$v)
                              },
                              expression: "midData.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "code", prop: "code" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.midData.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.midData, "code", $$v)
                              },
                              expression: "midData.code",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "权限", prop: "perms" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.midData.perms,
                              callback: function ($$v) {
                                _vm.$set(_vm.midData, "perms", $$v)
                              },
                              expression: "midData.perms",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "资源级别", prop: "system" },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "filter-item",
                                      attrs: { placeholder: "Please select" },
                                      model: {
                                        value: _vm.midData.system,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.midData, "system", $$v)
                                        },
                                        expression: "midData.system",
                                      },
                                    },
                                    _vm._l(_vm.systemOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.display_name,
                                          value: item.key,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "资源类型", prop: "type" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "filter-item",
                                      attrs: { placeholder: "Please select" },
                                      model: {
                                        value: _vm.midData.type,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.midData, "type", $$v)
                                        },
                                        expression: "midData.type",
                                      },
                                    },
                                    _vm._l(_vm.typesOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          label: item.display_name,
                                          value: item.key,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "图标" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.midData.icon,
                              callback: function ($$v) {
                                _vm.$set(_vm.midData, "icon", $$v)
                              },
                              expression: "midData.icon",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "路由路径", prop: "routerPath" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.midData.routerPath,
                              callback: function ($$v) {
                                _vm.$set(_vm.midData, "routerPath", $$v)
                              },
                              expression: "midData.routerPath",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sw-drawer__footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogFormVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.dialogStatus === "create"
                            ? _vm.createData()
                            : _vm.updateData()
                        },
                      },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }